import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main' // import the instance
import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import checkResponse from '@/utils/checkResponse'

const model = (payload) => ({
  // columns
  id: payload.id,
  concept: payload.concept
})
var crud = new Crud('AdministrativeConcepts', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  administrativeConcepts: [],
  administrativeConcept: {}
}

const mutations = {
  ...crud.mutations,
  UPDATE_RECORDS (state, payload) {
    const idx = state.administrativeConcepts.findIndex(u => u.id === payload.id)
    state.administrativeConcepts[idx] = payload
    if (idx >= 0) {
      Vue.set(state.administrativeConcepts, idx, payload)
    }
  }
}

const actions = {
  ...crud.actions,
  async editRecord ({ commit }, payload) {
    const record = model(payload)

    app.$Progress.start()
    try {
      const response = await axios.put(`administrative-concepts/${payload.id}`, record)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORDS', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.administrative_concept', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  administrativeConcepts: state => state.administrativeConcepts,
  administrativeConcept: state => state.administrativeConcept
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
